import { c as _c } from "react/compiler-runtime";
import { useDestination, useOrigin } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/hooks";
import { AutoCompleteInputPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/types";
import { AutoComplete } from "@website/ui/auto-complete";
import { FC } from "react";
export const AutoCompleteInput: FC<AutoCompleteInputPropertiesType> = properties => {
  const $ = _c(24);
  const {
    cityFromInitial,
    cityToInitial,
    errors,
    onChangeDestination,
    onChangeOrigin,
    originSuggestions,
    destinationSuggestions
  } = properties;
  const {
    originLoading,
    originListNormalized,
    onSelectOrigin,
    onChangeOriginQuery,
    selectedOriginText,
    originQuery,
    OriginNoResult,
    originLabel
  } = useOrigin(cityFromInitial?.title_fa || "", onChangeOrigin, originSuggestions);
  const {
    destinationLoading,
    destinationListNormalized,
    onSelectDestination,
    onChangeDestinationQuery,
    selectedDestinationText,
    destinationQuery,
    DestinationNoResult,
    destinationLabel
  } = useDestination(cityToInitial?.title_fa || "", onChangeDestination, destinationSuggestions);
  const t0 = errors?.originError || errors?.destinationError;
  let t1;
  if ($[0] !== OriginNoResult || $[1] !== onChangeOriginQuery || $[2] !== onSelectOrigin || $[3] !== originLabel || $[4] !== originListNormalized || $[5] !== originLoading || $[6] !== originQuery || $[7] !== selectedOriginText) {
    t1 = {
      label: originLabel,
      list: originListNormalized,
      text: selectedOriginText,
      onSelect: onSelectOrigin,
      onChangeQuery: onChangeOriginQuery,
      query: originQuery,
      loading: originLoading,
      NoResult: OriginNoResult
    };
    $[0] = OriginNoResult;
    $[1] = onChangeOriginQuery;
    $[2] = onSelectOrigin;
    $[3] = originLabel;
    $[4] = originListNormalized;
    $[5] = originLoading;
    $[6] = originQuery;
    $[7] = selectedOriginText;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== DestinationNoResult || $[10] !== destinationLabel || $[11] !== destinationListNormalized || $[12] !== destinationLoading || $[13] !== destinationQuery || $[14] !== onChangeDestinationQuery || $[15] !== onSelectDestination || $[16] !== selectedDestinationText) {
    t2 = {
      label: destinationLabel,
      list: destinationListNormalized,
      text: selectedDestinationText,
      onSelect: onSelectDestination,
      onChangeQuery: onChangeDestinationQuery,
      query: destinationQuery,
      loading: destinationLoading,
      NoResult: DestinationNoResult
    };
    $[9] = DestinationNoResult;
    $[10] = destinationLabel;
    $[11] = destinationListNormalized;
    $[12] = destinationLoading;
    $[13] = destinationQuery;
    $[14] = onChangeDestinationQuery;
    $[15] = onSelectDestination;
    $[16] = selectedDestinationText;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== t1 || $[19] !== t2) {
    t3 = [t1, t2];
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== t0 || $[22] !== t3) {
    t4 = <AutoComplete error={t0} fullWidth={true} parts={t3} />;
    $[21] = t0;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};